import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900">
          {t("notfound_title")}
        </h1>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">
          {t("notfound_desc")}
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {t("back_to_home")}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-left-line"></i>
          </span>
        </Link>
      </div>
    </div>
  );
}